import * as rcc from "../constants/rcc";
import * as actionTypes from "../constants/actionTypes";
import * as methods from "../constants/methods";
import * as componentTypes from "../constants/componentTypes";
import * as handlers from "../constants/handlers";
import * as settings from "../constants/settings";
import * as resources from "../constants/resources";
import * as modelHelper from "../helpers/modelHelper";
import * as changelogService from "../services/changelogService";
import * as windowService from "../services/windowService";

export const checkRccVersion = (response) => {
    let clientRccVersion = changelogService.getLastRccVersion().split(".");
    let rccVersion = response.data.version.split(".");

    if (clientRccVersion.length !== rccVersion.length) {
        return false;
    }

    for (let i = 0; i < clientRccVersion.length; i++) {
        if (Number(rccVersion[i]) < Number(clientRccVersion[i])) {
            return false;
        }
        if (Number(rccVersion[i]) > Number(clientRccVersion[i])) {
            return true;
        }
    }

    return true;
};

/**
 * Maps machine calls to RCC methods.
 *
 * @param   {Array} list
 * @returns {Object}
 */
export const processMethodList = (list) => {
    if (list === undefined || list === null || !Array.isArray(list)) {
        return {};
    }

    try {
        let availableMethods = {};

        let item;
        for (item of list) {
            switch (item) {
                case "info":
                    availableMethods[methods.METHOD_MACHINE_INFO] = true;
                    break;
                case "devices":
                    availableMethods[methods.METHOD_MACHINE_DEVICES] = true;
                    break;
                case "initialize":
                    availableMethods[methods.METHOD_MACHINE_START_INITIALIZE] = true;
                    break;
                case "reset":
                    availableMethods[methods.METHOD_MACHINE_START_RESET] = true;
                    break;
                case "hard_reset":
                    availableMethods[methods.METHOD_MACHINE_START_HARD_RESET] = true;
                    break;
                case "errors_reset":
                    availableMethods[methods.METHOD_MACHINE_START_ERRORS_RESET] = true;
                    break;
                case "validate_dispense_formula":
                    availableMethods[methods.METHOD_MACHINE_VALIDATE_FORMULA] = true;
                    break;
                case "dispense":
                    availableMethods[methods.METHOD_MACHINE_START_DISPENSE_FORMULA] = true;
                    break;
                case "dialog":
                    availableMethods[methods.METHOD_MACHINE_GET_DIALOG] = true;
                    break;
                case "dialog_action":
                    availableMethods[methods.METHOD_MACHINE_DIALOG_BUTTON_CLICK] = true;
                    break;
                case "canister_batch_numbers":
                    availableMethods[methods.METHOD_MACHINE_CANISTER_BATCH_NUMBERS] = true;
                    break;
                case "canisters":
                    availableMethods[methods.METHOD_MACHINE_CANISTERS] = true;
                    break;
                case "channels":
                    availableMethods[methods.METHOD_MACHINE_CHANNELS] = true;
                    break;
                case "move_table_to_refill":
                    availableMethods[methods.METHOD_MACHINE_MOVE_TABLE_TO_REFILL] = true;
                    break;
                case "add_canister_level":
                    availableMethods[methods.METHOD_MACHINE_ADD_CANISTER_LEVEL] = true;
                    break;
                case "set_canister_barcode":
                    availableMethods[methods.METHOD_MACHINE_SET_CANISTER_BARCODE] = true;
                    break;
                case "set_canister_level":
                    availableMethods[methods.METHOD_MACHINE_SET_CANISTER_LEVEL] = true;
                    break;
                case "set_canister_max_dispense_amount":
                    availableMethods[methods.METHOD_MACHINE_SET_MAX_DISPENSE_LEVEL] = true;
                    break;
                case "set_canister_dispense_logic_type":
                    availableMethods[methods.METHOD_MACHINE_SET_CANISTER_DISPENSE_LOGIC_TYPE] = true;
                    break;
                case "set_canister_threshold_percent":
                    availableMethods[methods.METHOD_MACHINE_SET_CANISTER_THRESHOLD_PERCENT] = true;
                    break;
                case "set_canister_ufi_code":
                    availableMethods[methods.METHOD_MACHINE_SET_CANISTER_UFI_CODE] = true;
                    break;
                case "shelf":
                    availableMethods[methods.METHOD_MACHINE_START_SHELF] = true;
                    break;
                case "punch":
                    availableMethods[methods.METHOD_MACHINE_START_PUNCH] = true;
                    break;
                case "plug":
                    availableMethods[methods.METHOD_MACHINE_START_PLUG] = true;
                    break;
                case "cap":
                    availableMethods[methods.METHOD_MACHINE_START_CAP] = true;
                    break;
                case "canister_batch_numbers_by_params":
                    availableMethods[methods.METHOD_MACHINE_GET_CANISTER_BATCH_NUMBERS] = true;
                    break;
                case "canister_ufi_codes_by_params":
                    availableMethods[methods.METHOD_MACHINE_GET_CANISTER_UFI_CODES] = true;
                    break;
                case "show_service_window":
                    availableMethods[methods.METHOD_MACHINE_SHOW_SERVICE_WINDOW] = true;
                    break;
                case "clean_channels":
                    availableMethods[methods.METHOD_MACHINE_START_CLEAN_CHANNELS] = true;
                    break;
                case "clean_all_channels":
                    availableMethods[methods.METHOD_MACHINE_START_CLEAN_ALL] = true;
                    break;
                case "recirculate_channels":
                    availableMethods[methods.METHOD_MACHINE_START_RECIRCULATE_CHANNELS] = true;
                    break;
                case "recirculate_all_channels":
                    availableMethods[methods.METHOD_MACHINE_START_RECIRCULATE_ALL] = true;
                    break;
                case "stir_canisters":
                    availableMethods[methods.METHOD_MACHINE_START_STIR_CANISTERS] = true;
                    break;
                case "stir_all_canisters":
                    availableMethods[methods.METHOD_MACHINE_START_STIR_ALL] = true;
                    break;
                case "purge":
                    availableMethods[methods.METHOD_MACHINE_START_PURGE] = true;
                    availableMethods[methods.METHOD_MACHINE_START_SMART_PURGE] = true;
                    break;
                case "purge_all":
                    availableMethods[methods.METHOD_MACHINE_START_PURGE_ALL] = true;
                    availableMethods[methods.METHOD_MACHINE_START_SMART_PURGE_ALL] = true;
                    break;
                case "errors":
                    availableMethods[methods.METHOD_MACHINE_GET_ERRORS] = true;
                    break;
                case "history_actions":
                    availableMethods[methods.METHOD_MACHINE_HISTORY_ACTIONS] = true;
                    break;
                case "history_refills":
                    availableMethods[methods.METHOD_MACHINE_HISTORY_REFILLS] = true;
                    break;
                case "sensors":
                    availableMethods[methods.METHOD_MACHINE_GET_SENSORS] = true;
                    break;
                case "history_last_actions":
                    availableMethods[methods.METHOD_MACHINE_HISTORY_LAST_ACTIONS] = true;
                    break;
                case "get_canister_by_barcode":
                    availableMethods[methods.METHOD_MACHINE_GET_CANISTER_BY_BARCODE] = true;
                    break;
                case "refill_canister":
                    availableMethods[methods.METHOD_MACHINE_START_CANISTER_REFILL] = true;
                    break;
                case "autotasks_list":
                    availableMethods[methods.METHOD_MACHINE_GET_AVAILABLE_AUTOTASK_TYPES] = true;
                    availableMethods[methods.METHOD_MACHINE_GET_AUTOTASKS] = true;
                    availableMethods[methods.METHOD_MACHINE_START_AUTOTASK] = true;
                    break;
                case "autotask_add_generic":
                    availableMethods[methods.METHOD_MACHINE_AUTOTASK_ADD_GENERIC] = true;
                    break;
                case "autotask_update_generic":
                    availableMethods[methods.METHOD_MACHINE_AUTOTASK_UPDATE_GENERIC] = true;
                    break;
                case "autotask_delete":
                    availableMethods[methods.METHOD_MACHINE_AUTOTASK_DELETE] = true;
                    break;
                case "backup_configuration":
                    availableMethods[methods.METHOD_MACHINE_BACKUP_CONFIGURATION] = true;
                    break;
                case "purge_rule_add":
                    availableMethods[methods.METHOD_MACHINE_PURGE_RULE_ADD] = true;
                    break;
                case "purge_rules_list":
                    availableMethods[methods.METHOD_MACHINE_PURGE_RULES_LIST] = true;
                    break;
                case "purge_rule_update":
                    availableMethods[methods.METHOD_MACHINE_PURGE_RULE_UPDATE] = true;
                    break;
                case "channel_purge_stats":
                    availableMethods[methods.METHOD_MACHINE_GET_PURGE_STATS] = true;
                    break;
                case "channel_dispense_stats":
                    availableMethods[methods.METHOD_MACHINE_GET_DISPENSE_STATS] = true;
                    break;
                case "channel_all_stats":
                    availableMethods[methods.METHOD_MACHINE_GET_ALL_STATS] = true;
                    break;
                case "disconnect":
                    availableMethods[methods.METHOD_MACHINE_START_DISCONNECT] = true;
                    break;
                case "dispense_manual":
                    availableMethods[methods.METHOD_MACHINE_MANUAL_FORMULA] = true;
                    break;
                case "colorant_prediction":
                    availableMethods[methods.METHOD_MACHINE_COLORANT_PREDICTION] = true;
                    break;
                default:
                    break;
            }
        }

        return availableMethods;
    } catch (e) {
        windowService.logError("4F167E145DF8BDE", e.message);
        return {};
    }
};

/**
 * Maps spectro calls to RCC methods.
 *
 * @param   {Array}     list
 * @returns {Object}
 */
export const processSpectroMethodList = (list) => {
    if (list === undefined || list === null || !Array.isArray(list)) {
        return {};
    }

    try {
        let availableMethods = {};

        let item;
        for (item of list) {
            switch (item) {
                case "info":
                    availableMethods[methods.METHOD_SPECTRO_GET_INFO] = true;
                    break;
                case "is_calibrated":
                    availableMethods[methods.METHOD_SPECTRO_IS_CALIBRATED] = true;
                    break;
                case "dialog":
                    availableMethods[methods.METHOD_SPECTRO_GET_DIALOG] = true;
                    break;
                case "dialog_action":
                    availableMethods[methods.METHOD_SPECTRO_DIALOG_BUTTON_CLICK] = true;
                    break;
                case "calibrate":
                    availableMethods[methods.METHOD_SPECTRO_START_CALIBRATE] = true;
                    break;
                case "measure":
                    availableMethods[methods.METHOD_SPECTRO_START_MEASURE] = true;
                    break;
                default:
                    break;
            }
        }

        return availableMethods;
    } catch (e) {
        windowService.logError("0B957CD302AC2FF", e.message);
        return {};
    }
};

export const processDeviceList = (list) => {
    if (list === undefined || list === null || !Array.isArray(list)) {
        return {};
    }

    try {
        let devices = {};

        let item;
        for (item of list) {
            devices[item.name] = item.present;
        }

        return devices;
    } catch (e) {
        windowService.logError("DDC87E3FE63D20A", e.message);
        return {};
    }
};

export const isDispenseCanisterStartedEventValid = (response) => {
    if (response.data === undefined) {
        return false;
    }

    if (response.data.meta === undefined || response.data.meta === null) {
        return false;
    }

    return true;
};

export const isDispenseCanisterDoneEventValid = (response) => {
    if (response.data === undefined) {
        return false;
    }

    if (
        response.data.meta === undefined ||
        response.data.meta === null ||
        response.data.numDone === undefined ||
        response.data.numTotal === undefined
    ) {
        return false;
    }

    return true;
};

export const getCanisterByRefillDialog = (dialog, canisters) => {
    if (canisters.length === 0 || dialog.params.length === 0) {
        return null;
    }

    let dialogParam = dialog.params[0];

    let canister;

    if (
        dialog.message === rcc.RCC_MESSAGE_REFILL_CANISTER ||
        dialog.message === rcc.RCC_MESSAGE_REFILL_CANISTER_BY_BARCODE
    ) {
        for (canister of canisters) {
            if (canister.colorant !== null && canister.id === dialogParam) {
                return canister;
            }
        }
    }

    for (canister of canisters) {
        if (canister.colorant !== null && canister.colorant.name === dialogParam) {
            return canister;
        }
    }

    return null;
};

export const mapColorantListForRcc = (colorantList) => {
    let result = [];

    let colorant;
    for (colorant of colorantList) {
        result.push({
            cntCode: colorant.name,
            density: colorant.density,
            rgb: colorant.rgb
        });
    }

    return result;
};

export const processDialogResponse = (method, data, state) => {
    if (data === undefined) {
        return [];
    }

    let dialog = modelHelper.createDialog(data, state);

    if (
        dialog.message === rcc.RCC_MESSAGE_VALIDATE_CAN ||
        ((dialog.message === rcc.RCC_MESSAGE_READ_BASE_UFI_CODE ||
            dialog.message === rcc.RCC_MESSAGE_VALIDATE_BASE_UFI_CODE) &&
            (state.settings.ufiCodeLogic === settings.UFI_CODE_LOGIC_DISABLED ||
                state.settings.ufiCodeLogic === settings.UFI_CODE_LOGIC_DB_VALUES))
    ) {
        return [
            {
                type: actionTypes.RCC_REQUEST,
                payload: {
                    type: methods.METHOD_MACHINE_DIALOG_BUTTON_CLICK,
                    params: {
                        dialogID: dialog.id,
                        msgBtn: rcc.RCC_BTN_CONTINUE
                    }
                },
                method: handlers.MACHINE_DIALOG_BUTTON_CLICK,
                tabId: 0,
                safe: false
            }
        ];
    }

    let dialogShowActions = [
        {
            type: actionTypes.SAVE_RCC_DIALOG,
            payload: {
                dialog: dialog
            }
        },
        {
            type: actionTypes.OPEN_RCC_DIALOG
        }
    ];

    if (
        dialog.message === rcc.RCC_MESSAGE_VALIDATE_BASE_CAN &&
        method !== handlers.MACHINE_GET_DIALOG_AND_SKIP_BARCODE
    ) {
        if (
            state.login.loggedUser.canEdit(resources.FUNCTION_VALIDATE_ORDER_PACKAGE) &&
            state.toDispense.dispensedOrder !== null
        ) {
            if (state.toDispense.dispensedOrder.note === null || state.toDispense.dispensedOrder.note.length === 0) {
                dialogShowActions.push({type: actionTypes.MACHINE_DIALOG_CONTINUE});
            }

            return dialogShowActions;
        }

        if (dialog.meta === null || !Array.isArray(dialog.meta.details)) {
            return [
                {
                    type: actionTypes.GET_BARCODES_BY_PRODUCT_BASE_PACKAGE,
                    payload: {
                        productName: null,
                        baseName: null,
                        packageName: null
                    }
                }
            ];
        }

        return [
            {
                type: actionTypes.GET_BARCODES_BY_PRODUCT_BASE_PACKAGE,
                payload: {
                    productName: dialog.meta.details[0] === undefined ? null : dialog.meta.details[0],
                    baseName: dialog.meta.details[1] === undefined ? null : dialog.meta.details[1],
                    packageName: dialog.meta.details[2] === undefined ? null : dialog.meta.details[2]
                }
            }
        ];
    }

    if (
        (dialog.message === rcc.RCC_MESSAGE_VALIDATE_BASE_CAN ||
            dialog.message === rcc.RCC_MESSAGE_PLACE_BASE_CAN ||
            dialog.message === rcc.RCC_MESSAGE_READ_BASE_UFI_CODE ||
            dialog.message === rcc.RCC_MESSAGE_VALIDATE_BASE_UFI_CODE) &&
        dialog.meta !== null &&
        dialog.meta.details !== undefined &&
        dialog.meta.details.length === 3
    ) {
        dialogShowActions.push({
            type: actionTypes.SERVER_REQUEST,
            payload: {
                type: methods.METHOD_GET_PRODUCT_IMAGE,
                params: {
                    productName: dialog.meta.details[0],
                    baseName: dialog.meta.details[1],
                    packageName: dialog.meta.details[2],
                    databaseName:
                        state.toDispense.dispensedOrder !== null ? state.toDispense.dispensedOrder.databaseName : null,
                    online: state.settings.imagesSource === settings.SOURCE_ONLINE
                }
            },
            method: handlers.GET_DISPENSING_PRODUCT_IMAGE,
            tabId: 0
        });
    }

    if (dialog.type === componentTypes.MACHINE_DIALOG_REFILL) {
        let refillCanister = getCanisterByRefillDialog(dialog, state.rcc.canisterList);

        if (refillCanister !== null) {
            dialogShowActions.push({
                type: actionTypes.RCC_REQUEST,
                payload: {
                    type: methods.METHOD_MACHINE_CANISTERS
                },
                method: handlers.MACHINE_CANISTERS,
                tabId: 0,
                safe: false
            });

            dialogShowActions.push({
                type: actionTypes.RCC_REQUEST,
                payload: {
                    type: methods.METHOD_MACHINE_GET_CANISTER_IMAGE,
                    params: {
                        index: refillCanister.id
                    }
                },
                method: handlers.MACHINE_GET_CANISTER_IMAGE,
                tabId: 0,
                safe: false
            });

            if (refillCanister.colorant !== null) {
                dialogShowActions.push({
                    type: actionTypes.SERVER_REQUEST,
                    payload: {
                        type: methods.METHOD_GET_PACKAGES_FOR_COLORANT,
                        params: {
                            colorantName: refillCanister.colorant.name
                        }
                    },
                    method: handlers.GET_PACKAGES_FOR_COLORANT_WITH_IMAGE,
                    tabId: 0
                });
            }
        }
    }

    return dialogShowActions;
};

export const mapMachineMessageCodes = (response) => {
    if (
        response.data === undefined ||
        response.data === null ||
        response.data.codes === undefined ||
        response.data.codes === null
    ) {
        return null;
    }

    let result = {};

    for (let code of Object.keys(response.data.codes)) {
        result[response.data.codes[code]] = code;
    }

    return result;
};
